import React from "react";
import { Lock } from "lucide-react";
import { flatSteps } from "@/lib/setupProgress";
import StepHeader from "./StepHeader";

export default function LockedStep({ stepId }) {
  const step = flatSteps().find((s) => s.id === stepId);
  return (
    <div className="flex flex-col h-full fade-up">
      <StepHeader
        eyebrow="Coming soon"
        title={step?.name || "Step"}
        subtitle="This step is part of the broader RevQ setup flow and will plug into its dedicated /edi endpoints in the next phase. For now, focus on Account, Providers, Clients and Linking — the prerequisites for charge capture."
      />
      <div className="mt-8 flex-1 flex items-center justify-center text-[var(--gray2)]">
        <div className="text-center max-w-[420px]">
          <div className="w-14 h-14 rounded-[16px] bg-white/55 border border-black/[.08] flex items-center justify-center mx-auto">
            <Lock size={20} className="text-[var(--gray2)]" />
          </div>
          <div className="text-[13px] font-semibold text-[var(--ink2)] mt-4">
            Locked for this preview
          </div>
          <div className="text-[11.5px] mt-1.5 leading-[1.55]">
            Once the prerequisite steps are complete and your tenant has providers + clients,
            we'll progressively unlock locations, EHR connection, clearinghouse enrollment and
            the rest of the wizard.
          </div>
        </div>
      </div>
    </div>
  );
}
